import {v4 as uuidv4} from 'uuid'
import BUILD_FOR_TESTING from './buildForTesting';

export const routes = {

    "login": {
        "url": (BUILD_FOR_TESTING as any) == "false" ? "/?:state&:email&:shop&:action" : uuidv4(),
        "template": require('./controlled-pages/login/login.html'),
        "title": "Login"
    },
    "testing": {
        "url": (BUILD_FOR_TESTING as any == "true" ? "/" : uuidv4()),
        "template": "<testing></testing>",
        "title": "For Testing"
    },
    "loginRegister": {
        "url": "/login-register/{identifier}",
        "title": "Bem vindo",
        "template": '<login-register page-label="Vamos realizar seu cadastro, é rápido!" identifier="$resolve.identifier"></login-reigster>',
        "sidebar": false,
        resolve: {
            identifier: ['$location', '$stateParams',function ($location, $stateParams) {
                if ($location.search().identifier) {
                    return $location.search().identifier;
                } else {
                    return $stateParams.identifier;
                }
            }],
        }
    },
    "password-reset-confirm-on-login": {
        "url": "/password-reset-confirm/:accessToken",
        "template": '<password-reset-confirm-page access-token="$resolve.accessToken" is-on-login-page="true"></password-reset-confirm-page/>',
        "title": "Redefinição de Senha",
        "sidebar": false,
        "resolve": {
            accessToken: ['$stateParams',function ($stateParams) {
                return $stateParams.accessToken
            }]
        }
    },
    "therms": {
        "url": "/therms",
        "template": '<therms></therms>',
        "title": "Termos de uso e política de Privacidade",
        "sidebar": false
    },
    "unregister": {
        "url": "/unregister",
        "template": '<unregister></unregister>',
        "title": "Excluir meu cadastro",
        "sidebar": false
    },
    "verify-email-phone": {
        "url": "/verify-email-phone",
        "template": '<verify-email-phone email="$resolve.email" phone="$resolve.phone" go-to="$resolve.goTo" ></verify-email-phone>',
        "title": "Verificar e-mail e telefone",
        "sidebar": false,
        params: {
            email: null,
            phone: null,
            userId:null
        },
        resolve: {
            email: ['$location', '$stateParams',function ($location, $stateParams) {
                if ($location.search().email) {
                    return $location.search().email;
                } else {
                    return $stateParams.email;
                }
            }
            ],
            phone: ['$location', '$stateParams',function ($location, $stateParams) {    
                    if ($location.search().phone) {
                        return $location.search().phone;
                    } else {
                        return $stateParams.phone;
                    }
                    }
            ],
            goTo: ['$state', ($state) => (routeName:string) => $state.go(routeName)]
        }
    }
}